// Module
var code = "<abx-building-header class=\"elevation-frame-4dp\" abx-title=\"vm.title\" description=\"vm.description\" actions=\"vm.actions\"> </abx-building-header> <abx-job-list abx-models=\"vm.jobs\" abx-fetch=\"vm.fetchJobs(skip, limit)\" abx-permissions=\"vm.permissions\"> </abx-job-list> ";
// Exports
module.exports = code;